
import './Outsourcing.scss';


const Outsourcing = () => {

//=========================================
return (

    <div className='Outsourcing'>
    <div className="outsourcing-content">
        <div className="contact-info">
        <h3>매쓰오토젠 학원 관련 솔루션 전문 개발업체</h3>
        <p className='text-primary'>맞춤개발 및 아웃소싱</p>
        <div className="phone-numbers">
            {/* <p>문의 : <strong>1800-0981</strong>&nbsp;&nbsp;&nbsp;&nbsp;개발자 직통 : <strong>010-8890-6672</strong></p> */}
            <p>문의 : <strong>1800-0981</strong></p>
            <p>개발자 직통 : <strong>010-8890-6672</strong></p>
        </div>
        </div>
    </div>
    </div>

);
};

export default Outsourcing;
